const Contact = require('@/lib/Contacts/Contact');
const NotFoundApiError = require('@/lib/Api/NotFoundApiError');

class ContactService {
    /**
     * @param {ApiClient} apiClient
     * @param {Hydrator} hydrator
     */
    constructor(
        apiClient,
        hydrator,
    ) {
        this.apiClient = apiClient;
        this.hydrator = hydrator;
    }

    /**
     * Retrieve a single contact from the API by ID.
     *
     * @param {Number} id
     *
     * @returns {Promise<Contact|null>}
     */
    find(id) {
        return this.apiClient
            .request(
                'GET',
                `contacts/${id}`,
            )
            .then(({ data }) => {
                // The response for this endpoint is a single object (or a 404).
                return this.hydrator.hydrate(data, new Contact());
            })
            .catch((error) => {
                if (error instanceof NotFoundApiError) {
                    // Resolve with null for 404 errors.
                    return null;
                }

                // Re-throw non 404 errors.
                throw error;
            });
    }

    /**
     * Retrieve a single contact from the API by ref.
     *
     * @param {string} ref
     *
     * @returns {Promise<Contact|null>}
     */
    findByRef(ref) {
        return this.apiClient
            .request(
                'GET',
                'contacts',
                {
                    ref,
                },
            )
            .then(({ data }) => {
                // The response for this endpoint is an array of objects, but we only want the first one.
                if (data.length > 0) {
                    return this.hydrator.hydrate(data[0], new Contact());
                }

                return null;
            });
    }
}

module.exports = ContactService;
